import builder from '../builder';
import ConcertGuitarist from '../../streamline-icons/bold/concert-guitarist.svg';

export default builder('IconConcertGuitaristBold', ConcertGuitarist);
